export default "__VITE_ASSET__BHH9dVl3__"